<template>
	<div>
		<b-table-simple small id="document-user-step">
			<b-thead head-variant="dark">
				<b-tr style="line-height: 24px" class="text-center text-bold">
					<b-th style="border: none !important; background-color: transparent !important; width: 16%">&nbsp;</b-th>
					<b-th style="width: 14%">{{ FormMSG(86, 'User') }}</b-th>
					<b-th style="width: 14%">{{ FormMSG(56, 'Gate keeper') }}</b-th>
					<b-th style="width: 14%">{{ FormMSG(61, 'Production accountant') }}</b-th>
					<b-th style="width: 14%">{{ FormMSG(58, 'UPM') }}</b-th>
					<b-th style="width: 14%">{{ FormMSG(59, 'Line producer') }}</b-th>
					<b-th style="width: 14%">{{ FormMSG(60, 'Studio') }}</b-th>
				</b-tr>
			</b-thead>
			<b-tbody class="text-center">
				<b-tr>
					<b-td>{{ FormMSG(62, 'Step 1') }}</b-td>
					<b-td>
						<b-form-checkbox
							id="step1.0"
							v-model="step1.owner"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled10"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step1, DOCUMENT_VALIDATION_LEVEL_STRING.OWNER)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step1.1"
							v-model="step1.gateKeeper"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled11"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step1, DOCUMENT_VALIDATION_LEVEL_STRING.GATE_KEEPER)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step1.2"
							v-model="step1.productionAccountant"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled12"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step1, DOCUMENT_VALIDATION_LEVEL_STRING.PRODUCTION_ACCOUNTANT)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step1.3"
							v-model="step1.upm"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled13"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step1, DOCUMENT_VALIDATION_LEVEL_STRING.UPM)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step1.4"
							v-model="step1.lineProducer"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled14"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step1, DOCUMENT_VALIDATION_LEVEL_STRING.LINE_PRODUCER)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step1.5"
							v-model="step1.studio"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled15"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step1, DOCUMENT_VALIDATION_LEVEL_STRING.STUDIO)"
						/>
					</b-td>
				</b-tr>
				<b-tr>
					<b-td>{{ FormMSG(63, 'Step 2') }}</b-td>
					<b-td>
						<b-form-checkbox
							id="step2.0"
							v-model="step2.owner"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled20"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step2, DOCUMENT_VALIDATION_LEVEL_STRING.OWNER)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step2.1"
							v-model="step2.gateKeeper"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled21"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step2, DOCUMENT_VALIDATION_LEVEL_STRING.GATE_KEEPER)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step2.2"
							v-model="step2.productionAccountant"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled22"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step2, DOCUMENT_VALIDATION_LEVEL_STRING.PRODUCTION_ACCOUNTANT)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step2.3"
							v-model="step2.upm"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled23"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step2, DOCUMENT_VALIDATION_LEVEL_STRING.UPM)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step2.4"
							v-model="step2.lineProducer"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled24"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step2, DOCUMENT_VALIDATION_LEVEL_STRING.LINE_PRODUCER)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step2.5"
							v-model="step2.studio"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled25"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step2, DOCUMENT_VALIDATION_LEVEL_STRING.STUDIO)"
						/>
					</b-td>
				</b-tr>
				<b-tr>
					<b-td>{{ FormMSG(64, 'Step 3') }}</b-td>
					<b-td>
						<b-form-checkbox
							id="step3.0"
							v-model="step3.owner"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled30"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step3, DOCUMENT_VALIDATION_LEVEL_STRING.OWNER)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step3.1"
							v-model="step3.gateKeeper"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled31"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step3, DOCUMENT_VALIDATION_LEVEL_STRING.GATE_KEEPER)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step3.2"
							v-model="step3.productionAccountant"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled32"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step3, DOCUMENT_VALIDATION_LEVEL_STRING.PRODUCTION_ACCOUNTANT)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step3.3"
							v-model="step3.upm"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled33"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step3, DOCUMENT_VALIDATION_LEVEL_STRING.UPM)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step3.4"
							v-model="step3.lineProducer"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled34"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step3, DOCUMENT_VALIDATION_LEVEL_STRING.LINE_PRODUCER)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step3.5"
							v-model="step3.studio"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled35"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step3, DOCUMENT_VALIDATION_LEVEL_STRING.STUDIO)"
						/>
					</b-td>
				</b-tr>
				<b-tr>
					<b-td>{{ FormMSG(65, 'Step 4') }}</b-td>
					<b-td>
						<b-form-checkbox
							id="step4.0"
							v-model="step4.owner"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled40"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step4, DOCUMENT_VALIDATION_LEVEL_STRING.OWNER)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step4.1"
							v-model="step4.gateKeeper"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled41"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step4, DOCUMENT_VALIDATION_LEVEL_STRING.GATE_KEEPER)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step4.2"
							v-model="step4.productionAccountant"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled42"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step4, DOCUMENT_VALIDATION_LEVEL_STRING.PRODUCTION_ACCOUNTANT)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step4.3"
							v-model="step4.upm"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled43"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step4, DOCUMENT_VALIDATION_LEVEL_STRING.UPM)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step4.4"
							v-model="step4.lineProducer"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled44"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step4, DOCUMENT_VALIDATION_LEVEL_STRING.LINE_PRODUCER)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							id="step4.5"
							v-model="step4.studio"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabled45"
							@change="handleCheckRoleByStep($event, DOCUMENT_VALIDATION_STEP.step4, DOCUMENT_VALIDATION_LEVEL_STRING.STUDIO)"
						/>
					</b-td>
				</b-tr>
				<b-tr>
					<b-td class="text-bold">{{ FormMSG(45, 'Signature') }}</b-td>
					<b-td>
						<b-form-checkbox
							v-model="toSignOwner"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabledToSignOwner"
							@change="handleCheckToSign($event, DOCUMENT_VALIDATION_LEVEL_STRING.OWNER)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							v-model="toSignGateKeeper"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabledToSignGateKeeper"
							@change="handleCheckToSign($event, DOCUMENT_VALIDATION_LEVEL_STRING.GATE_KEEPER)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							v-model="toSignProductionAccountant"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabledToSignProductionAccountant"
							@change="handleCheckToSign($event, DOCUMENT_VALIDATION_LEVEL_STRING.PRODUCTION_ACCOUNTANT)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							v-model="toSignUpm"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabledToSignUpm"
							@change="handleCheckToSign($event, DOCUMENT_VALIDATION_LEVEL_STRING.UPM)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							v-model="toSignLineProducer"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabledToSignLineProducer"
							@change="handleCheckToSign($event, DOCUMENT_VALIDATION_LEVEL_STRING.LINE_PRODUCER)"
						/>
					</b-td>
					<b-td>
						<b-form-checkbox
							v-model="toSignStudio"
							:value="true"
							:unchecked-value="false"
							size="lg"
							:disabled="disabledToSignStudio"
							@change="handleCheckToSign($event, DOCUMENT_VALIDATION_LEVEL_STRING.STUDIO)"
						/>
					</b-td>
				</b-tr>
				<b-tr>
					<b-td style="border: none !important; background-color: transparent !important; height: 46px">&nbsp;</b-td>
					<b-td style="border: none !important; background-color: transparent !important">&nbsp;</b-td>
					<b-td>
						<v-select
							v-model="selectedGateKeeper"
							@input="handleChange($event, DOCUMENT_VALIDATION_LEVEL_STRING.GATE_KEEPER)"
							:options="gateKeeperUserList"
							label="fullName"
							:disabled="isDisabled"
							v-if="toSignGateKeeper"
							:reduce="(option) => option.id"
							:placeholder="FormMSG(216562, 'Select a user')"
							:class="{ 'is-invalid': $v.selectedGateKeeper.$error }"
						/>
					</b-td>
					<b-td>
						<v-select
							@input="handleChange($event, DOCUMENT_VALIDATION_LEVEL_STRING.PRODUCTION_ACCOUNTANT)"
							v-model="selectedProductionAccountant"
							:options="productionAccountantUserList"
							label="fullName"
							:disabled="isDisabled"
							v-if="toSignProductionAccountant"
							:placeholder="FormMSG(216562, 'Select a user')"
							:reduce="(option) => option.id"
							:class="{ 'is-invalid': $v.selectedProductionAccountant.$error }"
						/>
					</b-td>
					<b-td>
						<v-select
							@input="handleChange($event, DOCUMENT_VALIDATION_LEVEL_STRING.UPM)"
							:reduce="(option) => option.id"
							v-model="selectedUpm"
							:disabled="isDisabled"
							:options="upmUserList"
							label="fullName"
							v-if="toSignUpm"
							:placeholder="FormMSG(216562, 'Select a user')"
							:class="{ 'is-invalid': $v.selectedUpm.$error }"
						/>
					</b-td>
					<b-td>
						<v-select
							@input="handleChange($event, DOCUMENT_VALIDATION_LEVEL_STRING.LINE_PRODUCER)"
							v-model="selectedLineProducer"
							:options="lineProducerUserList"
							label="fullName"
							:disabled="isDisabled"
							:reduce="(option) => option.id"
							v-if="toSignLineProducer"
							:placeholder="FormMSG(216562, 'Select a user')"
							:class="{ 'is-invalid': $v.selectedLineProducer.$error }"
						/>
					</b-td>
					<b-td>
						<v-select
							@input="handleChange($event, DOCUMENT_VALIDATION_LEVEL_STRING.STUDIO)"
							v-model="selectedStudio"
							:options="studioUserList"
							label="fullName"
							:disabled="isDisabled"
							:reduce="(option) => option.id"
							v-if="toSignStudio"
							:placeholder="FormMSG(216562, 'Select a user')"
							:class="{ 'is-invalid': $v.selectedStudio.$error }"
						/>
					</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
		<div style="margin-top: -16px; font-weight: bold; color: red" class="w-100 d-flex justify-content-start align-items-center" v-if="isUserStepSelected">
			<div style="font-size: 1.5rem">*</div>
			<div class="pl-1">{{ FormMSG(7877, 'Please choose an approval step for the user(s)') }}</div>
		</div>
	</div>
</template>

<script>
import languageMessages from '@/mixins/languageMessages';
import _ from 'lodash';
import { getSignUsers } from '@/cruds/document.crud';
import {
	DOCUMENT_VALIDATION_STEP,
	DOCUMENT_VALIDATION_LEVEL,
	DOCUMENT_VALIDATION_LEVEL_ID_TO_STRING,
	DOCUMENT_VALIDATION_LEVEL_STRING
} from '@/shared/constants';
import { noTilde } from '~utils';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
	name: 'ChoiceStepDocument',
	mixins: [languageMessages, validationMixin],
	props: {
		isDisabled: { type: Boolean, default: false },
		currentDocument: { type: Object, required: true }
	},
	data() {
		return {
			step1: {
				owner: false,
				gateKeeper: false,
				productionAccountant: false,
				upm: false,
				lineProducer: false,
				studio: false,
				userId: 0
			},
			step2: {
				owner: false,
				gateKeeper: false,
				productionAccountant: false,
				upm: false,
				lineProducer: false,
				studio: false,
				userId: 0
			},
			step3: {
				owner: false,
				gateKeeper: false,
				productionAccountant: false,
				upm: false,
				lineProducer: false,
				studio: false,
				userId: 0
			},
			step4: {
				owner: false,
				gateKeeper: false,
				productionAccountant: false,
				upm: false,
				lineProducer: false,
				studio: false
			},
			selectedGateKeeper: null,
			selectedProductionAccountant: null,
			selectedUpm: null,
			selectedLineProducer: null,
			selectedStudio: null,
			toSignGateKeeper: false,
			toSignUpm: false,
			toSignStudio: false,
			allUserList: null,
			gateKeeperUserList: [],
			productionAccountantUserList: [],
			upmUserList: [],
			lineProducerUserList: [],
			studioUserList: [],
			roleByStepToSend: [],
			DOCUMENT_VALIDATION_LEVEL,
			DOCUMENT_VALIDATION_STEP,
			DOCUMENT_VALIDATION_LEVEL_ID_TO_STRING,
			DOCUMENT_VALIDATION_LEVEL_STRING,
			functionValidators: [
				DOCUMENT_VALIDATION_LEVEL_STRING.OWNER,
				DOCUMENT_VALIDATION_LEVEL_STRING.GATE_KEEPER,
				DOCUMENT_VALIDATION_LEVEL_STRING.PRODUCTION_ACCOUNTANT,
				DOCUMENT_VALIDATION_LEVEL_STRING.UPM,
				DOCUMENT_VALIDATION_LEVEL_STRING.LINE_PRODUCER,
				DOCUMENT_VALIDATION_LEVEL_STRING.STUDIO
			],
			/**
			 * [{
			 *	field: 'gateKeeper',
			 *  step: 1,
			 *  userId: 0
			 * }]
			 */
			assignedValidators: [],
			stepNumber: 4,
			toSignOwner: false,
			toSignProductionAccountant: false,
			toSignLineProducer: false,
			isDisabledToSignOwner: false,
			isDisabledToSignGateKeeper: false,
			isDisabledToSignProductionAccountant: false,
			isDisabledToSignUpm: false,
			isDisabledToSignLineProducer: false,
			isDisabledToSignStudio: false,
			isDisabled10: false,
			isDisabled11: false,
			isDisabled12: false,
			isDisabled13: false,
			isDisabled14: false,
			isDisabled15: false,
			isDisabled20: false,
			isDisabled21: false,
			isDisabled22: false,
			isDisabled23: false,
			isDisabled24: false,
			isDisabled25: false,
			isDisabled30: false,
			isDisabled31: false,
			isDisabled32: false,
			isDisabled33: false,
			isDisabled34: false,
			isDisabled35: false,
			isDisabled40: false,
			isDisabled41: false,
			isDisabled42: false,
			isDisabled43: false,
			isDisabled44: false,
			isDisabled45: false,
			document: null
		};
	},
	async created() {
		this.assignedValidators = [];
		this.roleByStepToSend = [];
		await this.initApprovalMatrix();
	},
	computed: {
		disabled10: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled10;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled11: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled11;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled12: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled12;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled13: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled13;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled14: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled14;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled15: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled15;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled20: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled20;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled21: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled21;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled22: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled22;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled23: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled23;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled24: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled24;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled25: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled25;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled30: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled30;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled31: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled31;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled32: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled32;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled33: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled33;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled34: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled34;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled35: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled35;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled40: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled40;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled41: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled41;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled42: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled42;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled43: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled43;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled44: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled44;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabled45: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabled45;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabledToSignOwner: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabledToSignOwner;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabledToSignGateKeeper: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabledToSignGateKeeper;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabledToSignProductionAccountant: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabledToSignProductionAccountant;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabledToSignUpm: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabledToSignUpm;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabledToSignLineProducer: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabledToSignLineProducer;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		disabledToSignStudio: {
			get: function () {
				if (!this.isDisabled) {
					return this.isDisabledToSignStudio;
				}

				return true;
			},
			set: function (value) {
				return value;
			}
		},
		isUserStepSelected() {
			return this.assignedValidators.findIndex((assignedValidator) => assignedValidator.field === DOCUMENT_VALIDATION_LEVEL_STRING.OWNER) === -1;
		}
	},
	watch: {
		currentDocument: {
			handler(value) {
				if (!_.isNil(value)) {
					this.document = value;
				}
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		filterUserOfOtherRole() {
			this.productionAccountantUserList = this.allUserList.productionAccountants
				.filter(
					(user) =>
						user.id !== +this.selectedGateKeeper &&
						user.id !== +this.selectedUpm &&
						user.id !== +this.selectedLineProducer &&
						user.id !== +this.selectedStudio
				)
				.map((user) => {
					let usrData = {
						id: +user.id,
						fullName: user.name + ' ' + user.firstName
					};

					return usrData;
				});
			this.productionAccountantUserList = this.orderByFullName(this.productionAccountantUserList);

			this.upmUserList = this.allUserList.upm
				.filter(
					(user) =>
						user.id !== +this.selectedGateKeeper &&
						user.id !== +this.selectedProductionAccountant &&
						user.id !== +this.selectedLineProducer &&
						user.id !== +this.selectedStudio
				)
				.map((user) => {
					let usrData = {
						id: +user.id,
						fullName: user.name + ' ' + user.firstName
					};

					return usrData;
				});
			this.upmUserList = this.orderByFullName(this.upmUserList);

			this.lineProducerUserList = this.allUserList.lineProducers
				.filter(
					(user) =>
						user.id !== +this.selectedGateKeeper &&
						user.id !== +this.selectedUpm &&
						user.id !== +this.selectedProductionAccountant &&
						user.id !== +this.selectedStudio
				)
				.map((user) => {
					let usrData = {
						id: +user.id,
						fullName: user.name + ' ' + user.firstName
					};

					return usrData;
				});
			this.lineProducerUserList = this.orderByFullName(this.lineProducerUserList);

			this.studioUserList = this.allUserList.studios
				.filter(
					(user) =>
						user.id !== +this.selectedGateKeeper &&
						user.id !== +this.selectedUpm &&
						user.id !== +this.selectedLineProducer &&
						user.id !== +this.selectedProductionAccountant
				)
				.map((user) => {
					let usrData = {
						id: +user.id,
						fullName: user.name + ' ' + user.firstName
					};

					return usrData;
				});
			this.studioUserList = this.orderByFullName(this.studioUserList);

			this.gateKeeperUserList = this.allUserList.gateKeepers
				.filter(
					(user) =>
						user.id !== +this.selectedProductionAccountant &&
						user.id !== +this.selectedUpm &&
						user.id !== +this.selectedLineProducer &&
						user.id !== +this.selectedStudio
				)
				.map((user) => {
					let usrData = {
						id: +user.id,
						fullName: user.name + ' ' + user.firstName
					};

					return usrData;
				});
			this.gateKeeperUserList = this.orderByFullName(this.gateKeeperUserList);
		},
		orderByFullName(list) {
			list.sort((a, b) => {
				if (noTilde(a.fullName).toLowerCase() < noTilde(b.fullName).toLowerCase()) {
					return -1;
				}
				if (noTilde(a.fullName).toLowerCase() > noTilde(b.fullName).toLowerCase()) {
					return 1;
				}

				return 0;
			});

			return list;
		},
		handleChange(payload, field) {
			const idx = this.assignedValidators.findIndex((assignedValidator) => assignedValidator.field === field);
			this.assignedValidators[idx].userId = +payload;

			const item = this.roleByStepToSend.filter((item) => item.field === field)[0];
			this.roleByStepToSend[item.index].userId = +payload;

			this.$emit('choice-step-document:change', this.roleByStepToSend);
		},
		async getUserList() {
			await getSignUsers().then((users) => {
				this.allUserList = users;

				this.gateKeeperUserList = users.gateKeepers.map((user) => {
					let usrData = {
						id: +user.id,
						fullName: user.name + ' ' + user.firstName
					};

					return usrData;
				});

				this.productionAccountantUserList = users.productionAccountants.map((user) => {
					let usrData = {
						id: +user.id,
						fullName: user.name + ' ' + user.firstName
					};

					return usrData;
				});

				this.upmUserList = users.upm.map((user) => {
					let usrData = {
						id: +user.id,
						fullName: user.name + ' ' + user.firstName
					};

					return usrData;
				});

				this.lineProducerUserList = users.lineProducers.map((user) => {
					let usrData = {
						id: +user.id,
						fullName: user.name + ' ' + user.firstName
					};

					return usrData;
				});

				this.studioUserList = users.studios.map((user) => {
					let usrData = {
						id: +user.id,
						fullName: user.name + ' ' + user.firstName
					};

					return usrData;
				});
			});
		},
		handleCheckRoleByStep(payload, step, field) {
			this.$v.$touch();
			/**
			 * work on row and disable others col necessary => axe X
			 */
			for (let i = 0; i < this.functionValidators.length; i++) {
				const idx = this.assignedValidators.findIndex((assignedValidator) => assignedValidator.field === field && assignedValidator.step === step);
				if (i !== this.functionValidators.findIndex((validator) => validator === field)) {
					this[`isDisabled${step}${i}`] = payload;
					// insert in assignedValidators, but first check if exists
					if (this.assignedValidators.length === 0) {
						this.assignedValidators.push({
							field,
							step,
							userId: 0
						});
					} else {
						if (idx === -1) {
							if (payload === true) {
								this.assignedValidators.push({
									field,
									step,
									userId: 0
								});
							}
						} else {
							if (payload === false) {
								this.assignedValidators.splice(idx, 1);
								/**
								 * Fix exceptions
								 */
								if (this.assignedValidators.length > 0) {
									for (let j = step + 1; j <= this.stepNumber; j++) {
										const idxToDel = this.assignedValidators.findIndex((assignedValidator) => assignedValidator.step === j);
										if (idxToDel !== -1) {
											this.assignedValidators.splice(idxToDel, 1);
										}
									}
								}
							}
						}
					}
				}
			}

			this.manageNextStep(step, payload, field);

			this.setRoleSelected();

			this.$emit('choice-step-document:change', this.roleByStepToSend);
		},
		capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.substring(1);
		},
		getFieldToSign(field) {
			return this[`toSign${this.capitalizeFirstLetter(field)}`];
		},
		handleCheckToSign(payload, field) {
			// this.roleByStepToSend = roleByStepToSend;
			const item = this.roleByStepToSend.filter((item) => item.field === field)[0];
			if (item) {
				this.roleByStepToSend[item.index].toSign = payload;
			}

			this.$emit('choice-step-document:change', this.roleByStepToSend);
		},
		async initRoleByStep(doc) {
			this.filterUserOfOtherRole();
			let assignedValidators = [];

			for (let i = 1; i <= this.stepNumber; i++) {
				const docValConfigStep = doc[`docValConfigStep${i}`];

				for (const dvcs of docValConfigStep) {
					const field = DOCUMENT_VALIDATION_LEVEL_ID_TO_STRING[`${dvcs.validationLevel}`];

					assignedValidators.push({
						field,
						step: dvcs.step,
						userId: dvcs.userId
					});

					this[`step${i}`][`${field}`] = true;
					if (dvcs.validationLevel !== DOCUMENT_VALIDATION_LEVEL.owner) {
						this[`selected${this.capitalizeFirstLetter(field)}`] = dvcs.userId;
					}
					this[`toSign${this.capitalizeFirstLetter(field)}`] = dvcs.toSign;
				}
			}

			this.assignedValidators = assignedValidators;
			this.setRoleSelected();

			this.fixRoleDisabledStep();
			this.fixSignatureChecked();
		},
		manageNextStep(step, payload, field) {
			if (payload) {
				for (let i = step + 1; i <= this.stepNumber; i++) {
					for (let j = 0; j < this.functionValidators.length; j++) {
						if (i === step + 1) {
							setTimeout(() => {
								this[`isDisabled${i}${j}`] =
									this.assignedValidators.findIndex((assignedValidator) => assignedValidator.field === this.functionValidators[j]) !== -1;
							}, 250);
						} else {
							this[`isDisabled${i}${j}`] = true;
						}
					}
				}

				this[`toSign${this.capitalizeFirstLetter(field)}`] = payload;
				// this[`isDisabledToSign${this.capitalizeFirstLetter(field)}`] = payload;
				this[`isDisabledToSign${this.capitalizeFirstLetter(field)}`] = false;
			} else {
				for (let i = step; i <= this.stepNumber; i++) {
					for (let j = 0; j < this.functionValidators.length; j++) {
						if (i === step) {
							setTimeout(() => {
								this[`isDisabled${i}${j}`] =
									this.assignedValidators.findIndex((assignedValidator) => assignedValidator.field === this.functionValidators[j]) !== -1;
							}, 250);
						} else {
							this[`step${i}`][this.functionValidators[j]] = false;
							this[`isDisabled${i}${j}`] = true;
						}
					}
				}

				// fix signature checked
				if (this.assignedValidators.length === 0) {
					for (let i = 0; i < this.functionValidators.length; i++) {
						this[`toSign${this.capitalizeFirstLetter(this.functionValidators[i])}`] = false;
						this[`isDisabledToSign${this.capitalizeFirstLetter(this.functionValidators[i])}`] = true;
					}
				} else {
					this.fixSignatureChecked();
				}
			}
		},
		fixRoleDisabledStep() {
			if (this.assignedValidators.length > 0) {
				for (let i = 1; i <= this.stepNumber; i++) {
					const item = this.assignedValidators.filter((assignedValidator) => assignedValidator.step === i);
					for (let j = 0; j < this.functionValidators.length; j++) {
						if (this.functionValidators[j] !== item[0].field) {
							this[`isDisabled${i}${j}`] = true;
						}
					}

					const nextStepNextStep = this.assignedValidators.findIndex((assignedValidator) => assignedValidator.step === i + 1);
					if (nextStepNextStep === -1) {
						this.fixNextRoleDisabledStep(i + 1, this.assignedValidators);
						break;
					}
				}
			}
		},
		fixNextRoleDisabledStep(nextStep, assignedSteps) {
			for (let i = nextStep; i <= this.stepNumber; i++) {
				for (let j = 0; j < this.functionValidators.length; j++) {
					if (i === nextStep) {
						if (assignedSteps.findIndex((assignedStep) => assignedStep.field === this.functionValidators[j]) !== -1) {
							this[`isDisabled${i}${j}`] = true;
						}
					} else {
						this[`isDisabled${i}${j}`] = true;
					}
				}
			}
		},
		disableToSign() {
			for (let i = 0; i < this.functionValidators.length; i++) {
				this[`isDisabledToSign${this.capitalizeFirstLetter(this.functionValidators[i])}`] = true;
			}
		},
		fixSignatureChecked() {
			for (let i = 0; i < this.functionValidators.length; i++) {
				const item = this.assignedValidators.filter((assignedValidator) => assignedValidator.field === this.functionValidators[i]);
				if (item.length === 0) {
					this[`toSign${this.capitalizeFirstLetter(this.functionValidators[i])}`] = false;
				}
				this[`isDisabledToSign${this.capitalizeFirstLetter(this.functionValidators[i])}`] = true;
			}
		},
		setRoleSelected() {
			this.roleByStepToSend = [];

			if (this.assignedValidators.length > 0) {
				for (let i = 0; i < this.assignedValidators.length; i++) {
					this.roleByStepToSend.push({
						docId: +this.document.id,
						step: this.assignedValidators[i].step,
						validationLevel: DOCUMENT_VALIDATION_LEVEL[this.assignedValidators[i].field],
						toSign: this.getFieldToSign(this.assignedValidators[i].field),
						userId: this.assignedValidators[i].field === DOCUMENT_VALIDATION_LEVEL_STRING.OWNER ? -1 : this.assignedValidators[i].userId,
						field: this.assignedValidators[i].field,
						index: i
					});
				}
			}
		},
		async initApprovalMatrix() {
			if (this.document.requireManagerApproval === true) {
				await this.getUserList();
				if (
					this.document.docValConfigStep1.length > 0 ||
					this.document.docValConfigStep2.length > 0 ||
					this.document.docValConfigStep3.length > 0 ||
					this.document.docValConfigStep4.length > 0
				) {
					await this.initRoleByStep(this.document);
				} else {
					for (let i = 2; i <= this.stepNumber; i++) {
						for (let j = 0; j < this.functionValidators.length; j++) {
							this[`isDisabled${i}${j}`] = true;
						}
					}

					this.disableToSign();
				}
			}
		}
	},
	validations() {
		return {
			selectedGateKeeper: {
				required
			},
			selectedProductionAccountant: {
				required
			},
			selectedUpm: {
				required
			},
			selectedLineProducer: {
				required
			},
			selectedStudio: {
				required
			}
		};
	}
};
</script>
<style lang="scss">
#document-user-step tbody tr td,
#document-user-step .thead-dark tr th {
	border: 0.005rem solid rgba(226, 230, 235, 0.85) !important;
	border-collapse: collapse;
	font-size: 14px;
	letter-spacing: 0.05rem;
}

#document-user-step tbody tr td {
	vertical-align: middle;
}

#document-user-step tbody tr td .form-group {
	margin-bottom: 0;
}

#document-user-step tfoot tr th {
	vertical-align: middle;
	border-right: 0.005rem solid rgba(226, 230, 235, 0.85);
	border-bottom: 0.005rem solid rgba(226, 230, 235, 0.85);
}

#document-user-step .text-bold {
	font-weight: 600;
	font-size: 1.1rem;
}
</style>
